
import Vue, { RenderContext } from "vue";
import store from "@/store";
import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { Contexts } from "@/models/contexts";

const contentAvailable = (context, props) => {
  const userCan = store.getters["user/can"];

  const predicate =
    context === Contexts.CLIENT
      ? props.ifClient
      : context === Contexts.ADMIN
      ? props.ifAdmin
      : false;

  return _.isBoolean(predicate)
    ? predicate
    : _.isArray(predicate)
    ? userCan(...(predicate as string[]))
    : false;
};

const config = (context, props) => {
  const available = contentAvailable(context, props);

  return available && props.availableConfig
    ? props.availableConfig
    : !available && props.unavailableConfig
    ? props.unavailableConfig
    : {};
};

const renderContentNotAvailable = h => {
  return h("no-results", {
    props: {
      icon: "hand-paper",
      title: i18n.t("_.content_unavailable"),
      message: i18n.t("_sentence.content_unavailable_msg")
    }
  });
};

export default Vue.extend({
  name: "Guard",
  functional: true,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    ifAdmin: {
      required: true,
      type: [Array, Boolean]
    },
    ifClient: {
      type: Boolean,
      default: false
    },
    availableConfig: {
      type: Object,
      default: () => null
    },
    unavailableConfig: {
      type: Object,
      default: () => null
    }
  },
  render(h, ctx: RenderContext) {
    const context = store.state.context;
    const available = contentAvailable(context, ctx.props);
    const conf = config(context, ctx.props);

    if (available) {
      return ctx.children;
    } else {
      return h(_.get(conf, "tag", ctx.props.tag), conf, [
        renderContentNotAvailable(h)
      ]);
    }
  }
});
